import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SettingsShell } from "./SettingsShell";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function IntegrationsSettings() {
    const { user } = useAuth();
    const [rows, setRows] = useState([]);
    useEffect(() => { api.get("/integrations").then(({ data }) => setRows(data)); }, []);

    const extraTabs = user?.is_super_admin ? [{ to: "/app/settings/software-branding", label: "Software Branding" }] : [];

    return (
        <SettingsShell title="Integrations" subtitle="Connect third-party services. Full integration ships in Release 2." extraTabs={extraTabs}>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="integrations-grid">
                {rows.map((r) => {
                    const isAI = r.provider === "openai_via_emergent";
                    const isConnected = r.status === "connected";
                    return (
                        <div key={r.provider} className="border border-border p-6" data-testid={`integration-card-${r.provider}`}>
                            <div className="flex items-center justify-between">
                                <div className="overline">{r.category}</div>
                                <div className={`text-xs px-2 py-0.5 border ${isConnected ? "border-navy text-navy" : "border-border text-muted-foreground"}`} data-testid={`integration-status-${r.provider}`}>
                                    {isConnected ? "Live" : "Placeholder"}
                                </div>
                            </div>
                            <div className="mt-3 font-display text-xl tracking-tight capitalize flex items-center gap-2">
                                {isAI && <Sparkles size={14} className="text-navy" />}
                                {r.provider.replace(/_/g, " ")}
                            </div>
                            <p className="mt-2 text-sm text-muted-foreground">
                                {isAI ? "Live via Emergent universal key. Powers What's-Next explanations." : "Integration placeholder — live wiring arrives in Release 2."}
                            </p>
                        </div>
                    );
                })}
            </div>
        </SettingsShell>
    );
}
